import { computed, createBlock, openBlock, resolveDynamicComponent, unref, normalizeProps, guardReactiveProps } from "vue";
import error404 from "./Error404.vue.js";
import error503 from "./Error503.vue.js";
import defaultError from "./DefaultError.vue.js";
const _sfc_main = {
  __name: "ErrorPage",
  props: {
    error: Object
  },
  setup(__props) {
    const props = __props;
    const errorPage = computed(() => {
      if (props.error.statusCode === 404) {
        return error404;
      } else if (props.error.statusCode >= 500 && props.error.statusCode < 600) {
        return error503;
      }
      return defaultError;
    });
    return (_ctx, _cache) => {
      return openBlock(), createBlock(resolveDynamicComponent(unref(errorPage)), normalizeProps(guardReactiveProps(_ctx.$attrs)), null, 16);
    };
  }
};
export {
  _sfc_main as default
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRXJyb3JQYWdlLnZ1ZS5qcyIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvRXJyb3JzL0Vycm9yUGFnZS52dWUiXSwic291cmNlc0NvbnRlbnQiOlsiPHRlbXBsYXRlPlxuXHQ8Y29tcG9uZW50XG5cdFx0OmlzPVwiZXJyb3JQYWdlXCJcblx0XHR2LWJpbmQ9XCIkYXR0cnNcIiAvPlxuPC90ZW1wbGF0ZT5cblxuPHNjcmlwdCBzZXR1cD5cbmltcG9ydCBlcnJvcjQwNCBmcm9tIFwiLi9FcnJvcjQwNC52dWVcIjtcbmltcG9ydCBlcnJvcjUwMyBmcm9tIFwiLi9FcnJvcjUwMy52dWVcIjtcbmltcG9ydCBkZWZhdWx0RXJyb3IgZnJvbSBcIi4vRGVmYXVsdEVycm9yLnZ1ZVwiO1xuXG5jb25zdCBwcm9wcyA9IGRlZmluZVByb3BzKHtcblx0ZXJyb3I6IE9iamVjdCxcbn0pO1xuXG5jb25zdCBlcnJvclBhZ2UgPSBjb21wdXRlZCgoKSA9PiB7XG5cdGlmIChwcm9wcy5lcnJvci5zdGF0dXNDb2RlID09PSA0MDQpIHtcblx0XHRyZXR1cm4gZXJyb3I0MDQ7XG5cdH0gZWxzZSBpZiAocHJvcHMuZXJyb3Iuc3RhdHVzQ29kZSA+PSA1MDAgJiYgcHJvcHMuZXJyb3Iuc3RhdHVzQ29kZSA8IDYwMCkge1xuXHRcdHJldHVybiBlcnJvcjUwMztcblx0fVxuXHRyZXR1cm4gZGVmYXVsdEVycm9yO1xufSk7XG48L3NjcmlwdD5cbiJdLCJuYW1lcyI6WyJfY3JlYXRlQmxvY2siLCJfcmVzb2x2ZUR5bmFtaWNDb21wb25lbnQiLCJfdW5yZWYiLCJfbm9ybWFsaXplUHJvcHMiLCJfZ3VhcmRSZWFjdGl2ZVByb3BzIiwiJGF0dHJzIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7O0FBV0EsVUFBTSxRQUFRO0FBSWQsVUFBTSxZQUFZLFNBQVMsTUFBTTtBQUNoQyxVQUFJLE1BQU0sTUFBTSxlQUFlLEtBQUs7QUFDbkMsZUFBTztBQUFBLE1BQ1QsV0FBWSxNQUFNLE1BQU0sY0FBYyxPQUFPLE1BQU0sTUFBTSxhQUFhLEtBQUs7QUFDekUsZUFBTztBQUFBLE1BQ1Q7QUFDQyxhQUFPO0FBQUEsSUFDUixDQUFDOzswQkFyQkFBLFlBRW1CQyx3QkFEYkMsTUFBUyxTQUFBLENBQUEsR0FBQUMsZUFBQUMsbUJBQ05DLEtBQU0sTUFBQSxDQUFBLEdBQUEsTUFBQSxFQUFBO0FBQUE7OzsifQ==
